// Boutique opening hours (Khalidiyah Mall, Abu Dhabi): the ONE place they are
// written. Footer, Contact and About read from here.
//
// OWNER QUESTION: the site used to show three different sets of hours:
//   * Contact, About and the old JSON-LD: Sat–Thu 10:00–22:00, Fri 14:00–22:00
//   * Footer: Sun–Thu 10:00–22:00, Fri–Sat 10:00–24:00
//   * Terms (unused InfoPage): Sun–Thu 09:00–18:00
// The majority value is used below until the owner confirms. While
// `confirmed` is false, the hours stay OUT of structured data
// (public/index.html JSON-LD) and llms.txt (backend, no hours), so search engines and assistants
// are not given a possibly wrong fact. Once confirmed, set `confirmed: true`
// and add `openingHoursSpecification` from `schema` to index.html.
export const STORE_HOURS = {
  confirmed: false,
  lines: [
    { en: 'Saturday – Thursday: 10:00 AM – 10:00 PM', ar: 'السبت – الخميس: ١٠ص – ١٠م' },
    { en: 'Friday: 2:00 PM – 10:00 PM', ar: 'الجمعة: ٢م – ١٠م' },
  ],
  short: { en: 'Sat–Thu 10am–10pm · Fri 2pm–10pm', ar: 'السبت–الخميس ١٠ص–١٠م · الجمعة ٢م–١٠م' },
  // schema.org OpeningHoursSpecification, for when the hours are confirmed.
  schema: [
    { dayOfWeek: ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday'], opens: '10:00', closes: '22:00' },
    { dayOfWeek: ['Friday'], opens: '14:00', closes: '22:00' },
  ],
};

export default STORE_HOURS;
